import userOffline from './actions/userOffline/config';
import userOnline from './actions/userOnline/config';

export default [
  userOffline,
  userOnline
];